<template>
    <div class="container">
     <img
            :src='require("@/assets/images/ajax-loader.gif")'
            class="img-fluid bg-img w-100"
          />
    </div>
</template>
<script>
import * as api from '@/api'
import { mapGetters } from "vuex";


export default {
  computed: {
    ...mapGetters({
      globalError: "getGlobalError",
      appUserAuthed: 'auth/appUserAuthed',
      getLoaded: 'products/getLoaded',
      getAccessToken: 'auth/getAccessToken',
      webUserAuthed: 'auth/webUserAuthed',
    })
  },
  data() {
    return {
      logintitle: "Login",
      registertitle: "New Customer",
      errors: [],
      user: null,
      password: null
    };
  },
  methods:{
   productsTypeChange:(productsData)=>{
      var keys = Object.keys(productsData)
      var products = []
      keys.forEach((key,index)=>{
        if(index===Number(key))
          products.push(productsData[key])
      })
      return products
    },
    async getWebAccount() {
      var {query}    = this.$route
      // Only run this if it is not the App
      if(query.c  === undefined) {
        this.$router.push({name: 'shop'}) // switches page, and loads account in background
        var {dispatch} = this.$store
        dispatch('auth/getAccount', {register_it: 0})
      }
    },
  },
  watch: {
    getAccessToken: async function() {
      this.getWebAccount();
    }
  },
  async mounted() {

    var {query}    = this.$route
    var {dispatch} = this.$store

    var appSetting = async (data)=>{
      // This is a function called AFTER the appUser accesstoken was requested below. DO NOT call this function with Web Signin
      dispatch('auth/setAppUserToken',data)

      // special auth, direct API call for APP_USER
      var account = await api.getAccount( {register_it: 0 },{'authorization':data.data.appat});
      dispatch('auth/setAppUserData', account)


      // This is ONLY for App sign in, where always signed in, bypass the web start with cartid etc.
      if(!this.getLoaded) {
        var productsDat = await api.getProducts({'authorization':data.data.appat})
        var products    = this.productsTypeChange(productsDat.data)
        dispatch('products/setProducts',products)
      }
      var shoppingCart = await api.getShopingcart({'authorization':data.data.appat})
      dispatch('cart/setShoppingCart',shoppingCart)

      if(query.os  === 'android') {
        this.$router.push({name:'shop'})
      }
      else {
        this.$router.push({name:'settings'})
      }
    }

    if(query.c  === undefined) {

    } else {
      // For App login use the params to get the access token via API.
      api.getToken({t:query.t,c:query.c}).then(data=>{
        appSetting(data);
      })
    }

  }
};
</script>
